import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '../constants/api.constants';

/**
 * Persists auth tokens. Swap implementation if you move to httpOnly cookies.
 */
@Injectable({ providedIn: 'root' })
export class TokenService {
  getToken(): string | null {
    if (typeof sessionStorage === 'undefined') {
      return null;
    }
    return sessionStorage.getItem(STORAGE_KEYS.accessToken);
  }

  setToken(token: string): void {
    sessionStorage.setItem(STORAGE_KEYS.accessToken, token);
  }

  clearToken(): void {
    sessionStorage.removeItem(STORAGE_KEYS.accessToken);
  }
}
